import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=7c33575c&scoped=true&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"
import style0 from "./adminList.vue?vue&type=style&index=0&id=7c33575c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c33575c",
  null
  
)

export default component.exports